export default "__VITE_ASSET__36974e3f__"